import { PartNoBg } from '../styledComponents'
import TruncateText from '$components/TruncateText'

const createColumnsSummary = (t) => {
  const columns = [
    // {
    //   title: "Feasible",
    //   dataIndex: "feasible",
    //   className: "feas-col"
    // },
    //Table.EXPAND_COLUMN,
    {
      title: t('Part No'),
      dataIndex: 'id_part_client', //data["id_part_client"],
      //...getColumnSearchProps('id_part_client'),
      render: (title) => <PartNoBg>{title}</PartNoBg>,
      width: '160px',
    },
    {
      title: t('Part Name'),
      dataIndex: 'name',
      render: (text) => <TruncateText text={text} />,
      ellipsis: true,
      //...getColumnSearchProps('name'),
    },
    {
      title: t('Material'),
      render: (record) => {
        const materialName =
          record.client_material?.name || t('not_assigned', 'Not Assigned')
        return <TruncateText text={materialName} />
      },
      ellipsis: true,
    },
    {
      title: t('Quantity'),
      //dataIndex: "dimensions",
      //dataIndex: "attributes", //['attributes','0','value'],
      render: () => <>1</>,
    },
    {
      title: t('Price'),
      render: (record) =>
        record.float_attributes
          .filter((x) => x.key === 'Price')
          ?.map((row) => row.value)[0],
    },
  ]

  return columns
}

export default createColumnsSummary
